import React, { useState } from "react";

export default function App() {
  const [engineNumber, setEngineNumber] = useState("");
  const [status, setStatus] = useState("idle"); // idle, loading, verified, not_found, error
  const [vehicleNo, setVehicleNo] = useState(null);

  const GOOGLE_SHEET_CSV_URL =
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vSwcQSWmKdUVn7d_H541fMh4Ief600HRGFr37wPCi2LCl9XPPcH-U3e8GBROALuXOXMhIUD9t3VQS3a/pub?gid=754214932&single=true&output=csv";

  const handleSearch = async () => {
    if (!engineNumber.trim()) return;

    setStatus("loading");

    try {
      const res = await fetch(GOOGLE_SHEET_CSV_URL, {
        headers: { "Cache-Control": "no-cache" },
      });

      const csvText = await res.text();
      const rows = csvText.trim().split("\n").map((row) => row.split(/,|\t/));

      const data = rows.slice(1).map((r) => ({
        vehicle_no: r[0]?.trim(),
        engine_no: r[1]?.trim(),
      }));

      const found = data.find(
        (item) => item.engine_no?.toUpperCase() === engineNumber.toUpperCase()
      );

      if (found) {
        setVehicleNo(found.vehicle_no);
        setStatus("verified");
      } else {
        setVehicleNo(null);
        setStatus("not_found");
      }
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  return (
    <div className="app-layout">
      <header className="main-header">
        <div className="header-content">
          <img
            src="/logo.png"
            alt="Club Logo"
            className="header-logo"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/placeholder-logo.png";
            }}
          />
          <h1 className="header-title">
            Suzuki Fronx Owners Club <br /> Sri Lanka
          </h1>
        </div>
      </header>

      <div className="main-content-container">
        <div className="verify-card">
          <h2 className="card-title">Vehicle Lookup</h2>
          <p className="card-subtitle">
            Enter your Engine Number to find your Vehicle Number
          </p>

          <input
            type="text"
            placeholder="Enter Engine Number"
            value={engineNumber}
            onChange={(e) => setEngineNumber(e.target.value)}
            className="engine-input"
          />
          <button onClick={handleSearch} className="btn btn-primary search-btn">
            Search
          </button>

          {status === "loading" && (
            <div className="status-section loading-section">
              <p className="status-text loading-text">Searching...</p>
            </div>
          )}

          {status === "verified" && (
            <div className="status-section result-section verified">
              <div className="verified-badge">
                <span className="badge-icon">✓</span>
              </div>
              <h3 className="status-text verified-text">VEHICLE NUMBER FOUND</h3>
              <p className="detail-label">Vehicle Number:</p>
              <p className="vehicle-highlight vehicle-font">{vehicleNo}</p>
            </div>
          )}

          {status === "not_found" && (
            <div className="status-section result-section not-found">
              <div className="notfound-badge">
                <span className="badge-icon">✕</span>
              </div>
              <h3 className="status-text notfound-text">NOT FOUND</h3>
              <p className="detail-label">
                The engine number does not match any active record yet. Please Try again tomorrow.
              </p>
            </div>
          )}

          {status === "error" && (
            <div className="status-section result-section error">
              <div className="error-badge">
                <span className="badge-icon">⚠</span>
              </div>
              <h3 className="status-text error-text">DATA CONNECTION ERROR</h3>
              <p className="detail-label">
                Unable to connect to the external data source.
              </p>
            </div>
          )}
        </div>
      </div>

      <footer className="main-footer">
        <p className="footer-text">
          &copy; {new Date().getFullYear()} Suzuki Fronx Owners Club Sri Lanka.
          <span className="footer-small"> All rights reserved.</span>
        </p>
      </footer>

      {/* STYLES */}
      <style>{`
        @font-face {
          font-family: 'FronxClubFont';
          src: url('/FE.ttf') format('truetype');
        }
          .main-footer {
  background: #f0f0f0;
  padding: 15px;
  text-align: center; /* This centers the text */
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
}
        .app-layout {
          display: flex;
          flex-direction: column;
          min-height: 100vh;
          background: #f0f2f5;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          color: #333;
        }
        .main-header {
          background: #fff;
          padding: 15px 30px;
          border-bottom: 4px solid #b00000;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          text-align: center;
        }
        .header-logo {
          width: 50px;
          height: auto;
          margin-bottom: 10px;
        }
        .header-title {
          font-size: 1rem;
          font-weight: 700;
        }
        .main-content-container {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 30px 15px;
        }
        .verify-card {
          max-width: 450px;
          width: 100%;
          background: #fff;
          border-radius: 12px;
          padding: 35px 25px;
          text-align: center;
          border: 1px solid #ddd;
          box-shadow: 0px 8px 25px rgba(0,0,0,0.1);
        }
        .card-title {
          color: #222;
          font-size: 26px;
          font-weight: 800;
          margin-bottom: 5px;
        }
        .card-subtitle {
          color: #555;
          margin-bottom: 25px;
          font-size: 15px;
        }
        .engine-input {
          width: 100%;
          padding: 12px 15px;
          font-size: 16px;
          border-radius: 8px;
          border: 1px solid #ccc;
          margin-bottom: 15px;
          box-sizing: border-box;
        }
        .search-btn {
          width: 100%;
        }
        .status-section {
          margin-top: 20px;
          padding: 15px;
          border-radius: 8px;
        }
        .vehicle-highlight {
          color: #d32f2f;
          font-size: 28px;
          font-weight: 800;
        }
        .vehicle-font {
          font-family: 'FronxClubFont', monospace;
        }
        .btn {
          padding: 12px 25px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 700;
          text-decoration: none;
          transition: background 0.3s;
          border: none;
        }
        .btn-primary {
          background: #b00000;
          color: #fff;
        }
        .btn-primary:hover {
          background: #9a0000;
        }
      `}</style>
    </div>
  );
}
